import React from 'react';

import Table from 'components/Table';

import {formatDate} from 'utils/datetime';

import './styles.css';

const PreviewChargesSection = ({invoicesToPreview = []}) => {
  return (
    <div className="PreviewChargesSection">
      <div className="heading">Preview Charges</div>
      <div className="tableContainer">
        <div className="tableHeader">
          <Table>
            <Table.Header>
              <Table.HeaderItem heading="Name" className="name" />
              <Table.HeaderItem heading="Inv number" className="number" />
              <Table.HeaderItem
                heading="Earliest charge date"
                className="chargeDate"
              />
              <Table.HeaderItem heading="Due date" className="dueDate" />
              <Table.HeaderItem heading="Inv amount" className="amount" />
              <Table.HeaderItem heading="Outstanding" className="outstanding" />
              <Table.HeaderItem heading="Description" className="description" />
            </Table.Header>
          </Table>
        </div>
        <div className="tableBody">
          <Table>
            <Table.Body>
              {invoicesToPreview.map((inv: any) => (
                <Table.Row key={inv.id}>
                  <Table.Cell className="name">{inv.primaryTenant}</Table.Cell>
                  <Table.Cell className="number">{inv.idString}</Table.Cell>
                  <Table.Cell className="chargeDate">
                    {formatDate(inv.earliestChargeDate)}
                  </Table.Cell>
                  <Table.Cell className="dueDate">
                    {formatDate(inv.dueDate)}
                  </Table.Cell>
                  <Table.Cell className="amount">
                    {inv.totalIncludingTax}
                  </Table.Cell>
                  <Table.Cell className="outstanding">
                    {inv.totalDueIncludingTax}
                  </Table.Cell>
                  <Table.Cell className="description">
                    {inv.description}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default PreviewChargesSection;
